import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
  },
  reducers: {
    setUser: (state, action) => {
      if (
        typeof action.payload !== "object" ||
        !action.payload.user_id ||
        !action.payload.email ||
        !action.payload.type ||
        !action.payload.firstname ||
        !action.payload.lastname
      ) {
        console.error("Invalid user payload");
        return state;
      }
      state.user = action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;
